import React from 'react';

type StatusBadgeTone = 'live' | 'outline' | 'warn';

interface StatusBadgeProps {
  tone?: StatusBadgeTone;
  className?: string;
  children: React.ReactNode;
}

const BASE =
  'inline-block font-we-mono text-[10px] tracking-[0.12em] uppercase px-2.5 py-1 rounded-full';

const TONE_CLASS: Record<StatusBadgeTone, string> = {
  live: 'bg-we-accent-2/16 text-we-accent-2 border border-transparent',
  outline: 'bg-transparent text-we-ink/80 border border-we-ink/25',
  warn: 'bg-we-accent/35 text-we-clay border border-transparent',
};

const StatusBadge: React.FC<StatusBadgeProps> = ({
  tone = 'outline',
  className = '',
  children,
}) => (
  <span className={`${BASE} ${TONE_CLASS[tone]} ${className}`.trim()}>{children}</span>
);

export default StatusBadge;
